export const LOCAL_ID_PREFIX = 'locale-';

const MAX_GENIE = 100;
export const MAX_G_SYMPTOMS = MAX_GENIE;
export const MAX_G_DIAGNOSIS = MAX_GENIE;
export const MAX_G_MEDICATIONS = MAX_GENIE;
export const MAX_G_ADVICES = MAX_GENIE;
export const MAX_G_PRESCRIPTION_TEMPLATES = MAX_GENIE;
export const MAX_G_VITALS = MAX_GENIE;
export const MAX_G_LAB_TESTS = MAX_GENIE;
export const MAX_G_EXAMINATIONS = MAX_GENIE;
